import certStatus from '@/languages/ko-kr/cert-status'

export default {
  'certificate': '@:terms.certificate',
  'giro': '@:terms.giro',
  'code': '인증코드',
  'expiry-date': '@:terms.expired일자',
  'corporate': '@:terms.corporate@:terms.business-operator | ' +
    '@:terms.individual@:terms.business-operator',
  'register-action': '@:terms.register하기',
  'register-completed': '@:terms.register 완료',
  'delete': '삭제하기',
  'win-pc': '윈도우 PC',
  'title': {
    'page': ['@:terms.certificate', '등록하기'],
    'popup': ['@:terms.certificate', '등록에 필요한 준비항목'],
  },
  'message': {
    'page': '고지서 정보를 불러오기 위해 최초 1회 필요합니다.',
    'popup': '최초 1회 윈도우 PC가 필요합니다.',
    'empty': '@:terms.certificate @:pages.certificates.register-action',
    're-register': '@:terms.certificate 재@:pages.certificates.register-action',
    'pending': '인터넷지로에서 세금 납부시 사용하는 공동인증서를 등록해주세요.',
    'expired': '해당 공동인증서가 만료되었습니다.',
  },
  'will-expired': '오늘 @:terms.expired됩니다. | 내일 @:terms.expired됩니다. | ' +
    '{days}@:terms.days @:terms.after @:terms.expired됩니다.',
  'status': {
    ...certStatus,
  },
  'error': {
    'certificates': '@:terms.certificate 정보를 불러오는데 실패하였습니다.',
    'code': '@:pages.certificates.code를 가져오는데 실패하였습니다.',
    'delete': '@:terms.certificate를 삭제하는데 실패하였습니다.',
  },
  'steps': {
    'guide': '다음과 같은 단계로 등록 가능합니다.',
    '1': {
      'title': '주소로 공동인증센터 접속하기.',
      'description': '데스크탑 컴퓨터(윈도우)에서 \n공동인증서등록 서비스 홈페이지에 접속해주세요.',
    },
    '2': {
      'title': '공동인증센터의 안내에 따라 공동인증서를 등록하기.',
      'description': '등록 중에 인증코드를 입력하는 단계는 {code} 를 입력하시면 됩니다',
    },
  },
  'confirm': {
    'ok': '예',
    'cancel': '아니오',
    'message': {
      'delete': '@:terms.certificate를 삭제할까요?',
    },
  },
  'link': {
    'register-reason': '공동인증서가 왜 필요한가요?',
  },
  'individual': '개인@:terms.business-operator',
  'corporation': '@:terms.corporate@:terms.business-operator',
  'notRegister': '미@:terms.register',
  'guide': {
    '1': {
      'title': '@:pages.certificates.win-pc',
      'description': {
        '1': '',
        '2': '',
        '3': '',
        '4': '',
        '5': '',
        '6': '',
        '7': '',
      },
    },
    '2': {
      'title': '기업용 @:pages.certificates.certificate | 개인용 @:pages.certificates.certificate',
      'description': {
        '1': '- | - ',
        '2': ' | yessign(금융결제원)',
        '3': ' | 에서',
        '4': '법인 사업자등록번호 | 대표자 주민등록번호',
        '5': '로 발급한 | 로 발급한',
        '6': '범용 혹은 은행거래용 | 범용 혹은 은행거래용',
        '7': '@:pages.certificates.certificate | @:pages.certificates.certificate',
      },
    },
  },
  'guide-end': '* @:pages.certificates.certificate를 등록 후 이 창은 닫아주시면 됩니다.',
  'at-window': '@:pages.certificates.win-pc에서',
}
